/**
 * When to interrupt with an ad. A "match" is one round of the game (Tomato Pop: one focus session).
 *  - The very first match of a launch never shows an ad.
 *  - Every later match shows exactly one ad: a coin flip decides whether it comes before the match starts
 *    or after it ends, never both and never neither.
 * Breaks, setting up and discussing never show ads. The counter lives in memory: a new launch starts fresh.
 */
export interface AdPolicy {
    /** Call when a match is about to start. True = show the ad now, before it starts. */
    onMatchStart(): boolean;
    /** Call once a match's finishing animation is done. True = show the ad now. */
    onMatchEnd(): boolean;
}

export const createAdPolicy = (
    random: () => number = Math.random
): AdPolicy => {
    let matches = 0;
    let slot: 'start' | 'end' | null = null;
    return {
        onMatchStart: () => {
            matches += 1;
            slot = matches === 1 ? null : random() < 0.5 ? 'start' : 'end';
            return slot === 'start';
        },
        onMatchEnd: () => {
            const show = slot === 'end';
            slot = null;
            return show;
        },
    };
};
